import styled, { keyframes } from "styled-components";

// animação de rotação do contorno
const rotate = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// animação de pulso do círculo interno
const pulse = keyframes`
  0%, 100% { transform: scale(1); opacity: 1; }
  50% { transform: scale(0.8); opacity: 0.6; }
`;

// Container flexível, assume posição do pai
export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  height: fit-content;
`;

// Spinner com contorno giratório e flex centering
export const Spinner = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 8px solid #ddd;
    border-top-color: var(--red-color);
    border-radius: 50%;
    animation: ${rotate} 1s linear infinite;
  }
`;

// Círculo interno com texto RH e pulso, centralizado via flex
export const InnerCircle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background-color: #007acc;
  border-radius: 50%;
  animation: ${pulse} 1.2s ease-in-out infinite;
`;

// Label "RH" dentro do círculo interno
export const Label = styled.span`
  font-size: 16px;
  font-weight: bold;
  color: white;
  line-height: 1;
  text-align: center;
`;
